import { getFeatureFlags } from "@/utils/api.js";
import { defineStore } from "pinia";

export const defaultState = () => ({
    featureFlags : {},
    fetched: false,
});

export const useFeatureFlagStore = defineStore("feature_flag", {
    state: defaultState,
    getters: {
        // The only reason why we don't move this into constants.js is in case we add another model behind a feature flag
        waterModels() {
            return ['nwm', 'swe', 'hrdps', 'rdps', 'ecmwf', 'ecmwfSwe', 'hrrr', 'hrrrSwe', 'ukmo', 'ukmoSwe', 'hrdpsSwe'];
        },
    },
    actions: {
        async initializeFlagStore() {
            const myFlags = await getFeatureFlags();

            myFlags.forEach(flag => {
                this.featureFlags[flag.flagName] = flag.isEnabled;
            });

            this.fetched = true
        },
        clear() {
            this.$reset();
        }
    },
});
